module.exports = __webpack_public_path__ + "static/demo-2-e679a29e514bc4e9a8b4b351ec5d28a1.png";